import axios from 'axios';
import qs from 'qs';
import * as Sentry from '@sentry/browser';
import CitizenConfig from '../config';

export const REQUEST_RESULTS = 'REQUEST_RESULTS';
export const RECEIVE_RESULTS = 'RECEIVE_RESULTS';
export const INVALIDATE_RESULTS = 'INVALIDATE_RESULTS';
function requestResults(eraseLastState) {
  return {
    type: REQUEST_RESULTS,
    eraseLastState: eraseLastState,
  };
}

function receiveResults(json, page, eraseLastState) {
  if (eraseLastState) {
    return {
      type: 'RECEIVE_NEW_RESULTS',
      items: json.data,
      receivedAt: Date.now(),
      totalPages: json.headers['x-wp-totalpages']
    };
  } else {
    return {
      type: RECEIVE_RESULTS,
      items: json.data,
      receivedAt: Date.now(),
      totalPages: json.headers['x-wp-totalpages']
    };
  }
}

function fetchResults(searchQuery, type, page, eraseLastState) {
  return async (dispatch, getState) => {
    // pagination, 50 items per page
    const per_page = 50;
    const queryParams = {
      per_page,
      page,
      search: searchQuery,
    };
    const queryString = qs.stringify(queryParams);

    // todo
    // const searchUrl = `${CitizenConfig.API_URL}/wp/v2/product?${queryString}`;
    const searchUrl = `${CitizenConfig.API_URL}/wp/v1/products?${queryString}`;

    dispatch(requestResults(eraseLastState));

    return axios
      .get(searchUrl)
      .then(res => dispatch(receiveResults(res, page, eraseLastState)))
      .catch(err => {
        if (err.response.status === 404) {
          // this should not be treated as an error. Just let the results get cleared below
        } else {
          Sentry.captureException({
            type: "invalid search",
            error: err
          });
        }

        dispatch({ type: INVALIDATE_RESULTS });
      });
  };
}

function shouldFetchResults(state) {
  const posts = state;

  if (!posts.items) {
    return true;
  } else if (posts.isFetching) {
    return false;
  } else {
    return posts.didInvalidate;
  }
}

export function fetchResultsIfNeeded(searchQuery, type, page, eraseLastState) {
  return (dispatch, getState) => {
    if (shouldFetchResults(getState())) {
      return dispatch(fetchResults(searchQuery, type, page, eraseLastState));
    }
  };
}


// WEBPACK FOOTER //
// ./src/actions/ResultsActions.js